import { CanActivateFn, Router } from '@angular/router';;
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

export const AuthGuard: CanActivateFn = async(route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isReady()) {
    return false;
  }

  const isAuth = await auth.isLoggedIn();

  if (isAuth) {
    return true;
  }

  if (!state.url.startsWith('/signin')) {
    router.navigate(['/signin'], { replaceUrl: true });
  }


  return false;
};
